<template>
  <!-- 三层跟随鼠标移动的建筑 -->
  <div class="build" :class="{ buildMove: buildMoveNum != 0 }">
    <img
      v-for="(item, index) in imgSrc"
      :key="item"
      alt=""
      :src="item"
      :style="{ left: move_left / (index + 1) + 'px' }"
    />
  </div>
</template>

<script>
import { Bus } from "../bus";
export default {
  data() {
    return {
      move_left: 0,
      buildMoveNum: 0,
      // 建筑图片
      imgSrc: [
        require("../assets/images/in/0706-底层建筑-07.png"),
        require("../assets/images/in/0706-二层建筑-06.png"),
        require("../assets/images/in/0706-三层建筑-07-06.png")
      ]
    };
  },
  name: "Build",
  methods: {
    // 实现建筑跟随鼠标移动效果
    move_build() {
      window.onmousemove = e => {
        this.move_left = -e.x / 10;
      };
    }
  },
  mounted() {
    this.move_build();
  },
  created() {
    // 判断是否移动建筑图片大小和位置，总线获取liActiveNum，从AboutUs获取
    Bus.$on("liActiveNum", num => {
      this.buildMoveNum = num;
    });
  }
};
</script>

<style scoped>
.build {
  position: relative;
  width: 100%;
  z-index: 9;

  -webkit-transition: 1s linear;

  transition: 1s linear;
  -webkit-transform: translateY(-11.5rem);
  transform: translateY(-11.5rem);
}
.build img {
  position: absolute;
  width: 120%;
}
.buildMove {
  -webkit-transform: translateX(-40%) translateY(-11.5rem);
  transform: translateX(-40%) translateY(-11.5rem);
}
.build img:nth-child(1) {
  z-index: 0;
}
.build img:nth-child(2) {
  z-index: 1;
}
.build img:nth-child(3) {
  z-index: 2;
}
</style>
